module.exports = __webpack_public_path__ + "img/4_40.9967836e.png";